import React from 'react';

export const Header = ({title}) => {
    return <div className="widget__header">{title}</div>;
};
